// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__4pLdo","content":"Header_content__D6DKS","nav":"Header_nav__nS57w","logo":"Header_logo__3zqHD"};